import { mutations } from './mutations';
import { getters } from './getters';
import { actions } from './actions';
import { MlmState } from './state';

const defaultState: MlmState = {
  packagesList: [],
  activePackage: null,
  qualification: null,
  invoiceResponse: null,
  binaryTree: {},
  recentRegistrations: {
    next: 0,
    previous: 0,
    current: 0,
    count: 0,
    results: [],
  },
  transactionsResponse: {
    next: "",
    previous: "",
    current: 0,
    count: 0,
    results: [],
  },
  toggledTreeIds: [],
  treeUsersChildren: {},
  companyStats: {
    total_devices: 0,
    packages_500_count: 0,
    purchased_devices_count: 0,
  },
  userRefInfo: {
    users_count: 0,
    users_count_first_line: 0,
    levels_count: 0,
   // total_devices_in_all_branches: 0,
    max_branch_devices_count: 0,
    other_branches_devices_sum: 0,
        ring_purchases_count_in_ten_lines:0,
  t_package_purchases_count_in_ten_lines:0,
  ph_node_purchases_count_in_ten_lines:0,
  v_node_purchases_count_in_ten_lines:0,
  ring_purchases_count:0,
  t_package_purchases_count:0,
  ph_node_purchases_count:0,
  v_node_purchases_count:0,
  },
  userSigmaRings: [],
  sigmaRings: [],
  xcoinPackagesList: [],
  xcoinActivePackages: [],
  userXcoinPackagesList: [],
  physicalNodesList: [],
  physicalNodesActive: [],
  virtualNodesList: [],
  virtualNodesActive: [],
  userMonthlyTurnover: {
    period: "0",
  personal_turnover_month: "0",
  mini_turnover_month: "0",
  ten_line_turnover_month:"0",
  }
};

export const mlmModule = {
  state: defaultState,
  mutations,
  actions,
  getters,
};
